import { css } from '@emotion/css';

export const breadcrumbStyles = css`
  max-width: 25.6rem;
`;
